export default "__VITE_ASSET__BnPFMv_h__"